import { render, staticRenderFns } from "./vimeo.vue?vue&type=template&id=2cf879a2&scoped=true&"
import script from "./vimeo.vue?vue&type=script&lang=js&"
export * from "./vimeo.vue?vue&type=script&lang=js&"
import style0 from "./vimeo.vue?vue&type=style&index=0&id=2cf879a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf879a2",
  null
  
)

export default component.exports